module.exports = __webpack_public_path__ + "assets/b261a19836bbf4fa7dc59116cca4439b.png";